import angular from 'angular';
import template from './mobile-patient-actions.html';
class OneToOneMobilePatientActionsController {
    constructor(globalUi) {
        this.globalUi = globalUi;
    }
    toggleSideBar() {
        this.globalUi.ui.sidebarHidden = !this.globalUi.ui.sidebarHidden;
    }
}
const oneToOneMobilePatientActions = {
    template,
    bindings: {
        stream: '<',
        isInGroupCall: '<',
        username: '<',
        disabled: '<',
        onToggleAudio: '&',
        hasCallEnd: '<',
        onCallEnd: '&',
    },
    controller: OneToOneMobilePatientActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.participantVideoFrame.participantVideoFrameFull.actions.oneToOne.mobilePatientActions', [])
    // participant-one-to-one-mobile-patient-actions
    .component('participantOneToOneMobilePatientActions', oneToOneMobilePatientActions).name;
